import ProfilesPage from './ProfilesContext'
import RatingList from './RatingList'


export { RatingList }
export default ProfilesPage